export default __webpack_public_path__ + "c041d40b695020513a1f92d791fe4c9e.png";